import LeadFiles from './LeadFiles.component';

export default LeadFiles;
